import TripsManagerContainer from './TripsManagerContainer';

export default TripsManagerContainer;
